import { NAV_PATH } from '../../lib/nav';
import type { PageRoute } from '../../page-route';
import { MyAgentsPage } from './page';

/** «Мои ИИ-клиенты» (005, T059): в оболочке приложения, для любого вошедшего — свои подключения. */
export const route: PageRoute = { path: NAV_PATH.myAgents, access: 'authed', Component: MyAgentsPage };
